import * as React from 'react';
import { NewContractScreen } from '../components/contracts.js';

/**
 * `/smlouvy/nova` — nova smlouva ze sablony kancelare, ze vzoru REOS, nebo
 * z nahraneho Wordu (krok UXS1 bod 1). `?zakazka=<id>` ji sveze s konkretni
 * zakazkou, kdyz se zaklada z jeji zalozky Smlouvy.
 *
 * Krok SML1 bod 2: drobecek „Smlouvy › Nová smlouva" tady uz NENI — predloha
 * `SmlouvaNova.dc.html` ma vlevo nahore JEDNU cestu zpet („‹ Zavřít") a tu
 * kresli sama obrazovka. Dva navigacni prvky nad sebou byly dva nadpisy toho
 * stejneho (tentyz nalez jako tri nadpisy v prehledu, R.B. 1. 10.).
 */
export function SmlouvaNovaPage({ caseId }: { readonly caseId?: string | undefined }): React.JSX.Element {
  return (
    <div className="rh-v4-page" data-testid="smlouva-nova-page" data-guide="contract">
      <NewContractScreen {...(caseId !== undefined ? { caseId } : {})} />
    </div>
  );
}
